export const GET_REPORTED_MOMENTS = "GET_REPORTED_MOMENTS";
export const DISMISS_REPORT = "DISMISS_REPORT";
export const DELETE_POST = "DELETE_POST";